import React, { SVGProps } from 'react'
const SvgSidenavHelpCenterActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M10.833 1.875A8.125 8.125 0 0 0 3.42 13.329l-1.907 3.898c-.395.807.348 1.701 1.213 1.462l4.716-1.304a8.125 8.125 0 1 0 3.392-15.51ZM8.67 7.649c0-.54.621-1.343 1.974-1.343 1.283 0 2.135.712 2.135 1.654s-.852 1.624-1.122 1.835c-.552.43-.562.731-.562 1.252 0 .191-.1.412-.59.412-.412 0-.552-.15-.552-.672 0-.862.38-1.273.671-1.524.06-.05.128-.103.199-.157.318-.244.693-.532.693-.975 0-.461-.4-.682-.902-.682-.591 0-.767.259-.915.476-.107.159-.2.296-.428.296-.27 0-.601-.18-.601-.572Zm1.082 5.273a.77.77 0 0 1 .762-.772c.42 0 .772.35.772.772 0 .41-.341.772-.772.772a.77.77 0 0 1-.762-.772Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavHelpCenterActive
